import { CURRENCY_SIGNS } from '@/shared/constants';

export function getCurrencySign(code: string): string {
    return CURRENCY_SIGNS[code] ?? code;
}
